import { CampaignChannels } from './marketing';

export interface PaymentError {
	id: number;
	entity_type: string;
	entity_id: string;
	type_error: TypeError;
	error_message: string;
	input_data: InputData | null;
	error_data: null;
	is_resolved: boolean;
	created_at: string;
	updated_at: string;
	case_name: string;
}

export interface InputData {
	type: CampaignChannels;
	ad_id: string;
	case_id: string;
	channel_id: string;
	campaign_id: string;
}

export type TypeError =
	| 'PAYPAL_INSUFFICIENT_FUNDS'
	| 'PAYPAL_API_FAILURE'
	| 'PAYPAL_LIMIT_REACHED'
	| 'PAYPAL_CONNECTION_ERROR'
	| 'META_API_FAILURE'
	| 'META_INCORRECT_IMAGE_ASPECT_RATIO'
	| 'META_LOW_AMOUNT_BUDGET'
	| 'META_CREDIT_CARD_NOT_FUNDS'
	| 'META_GEOGRAPHIC_OVERLAP'
	| 'GOOGLE_ADS_FAILURE'
	| 'GOOGLE_ADS_INCORRECT_IMAGE_ASPECT_RATIO'
	| 'GOOGLE_ADS_CHARACTER_LIMIT_EXCEEDED'
	| 'GOOGLE_ADS_CREDIT_CARD_NOT_FUNDS';

export const ErrorsDir: Record<TypeError, string> = {
	PAYPAL_INSUFFICIENT_FUNDS: '',
	PAYPAL_API_FAILURE: '',
	PAYPAL_LIMIT_REACHED: '',
	PAYPAL_CONNECTION_ERROR: '',
	META_API_FAILURE: '',
	META_INCORRECT_IMAGE_ASPECT_RATIO:
		'Error: Image with incorrect aspect ratio.',
	META_LOW_AMOUNT_BUDGET: 'Error: Low amount defined in the budget.',
	META_CREDIT_CARD_NOT_FUNDS: 'Error: Credit card with no funds or expired.',
	META_GEOGRAPHIC_OVERLAP: 'Error: Geographic overlap.',
	GOOGLE_ADS_FAILURE: '',
	GOOGLE_ADS_INCORRECT_IMAGE_ASPECT_RATIO:
		'Error: Image with incorrect aspect ratio.',
	GOOGLE_ADS_CHARACTER_LIMIT_EXCEEDED: 'Error: Character limit exceeded.',
	GOOGLE_ADS_CREDIT_CARD_NOT_FUNDS:
		'Error: Credit card with no funds or expired.',
};
